import React, { FC } from 'react';
import { AuthenticationContainer } from '@components/organisms/AuthenticationContainer';
import { TwoFactorAuthActivateCard } from '@components/molecules/authentication/TwoFactorAuthActivateCard';

export const TwoFactorAuthActivate: FC = () => {
    return (
        <AuthenticationContainer>
            <TwoFactorAuthActivateCard />
        </AuthenticationContainer>
    );
};
